<template>
  <Vue3DraggableResizable v-model:w="w" v-model:h="h" v-model:x="x" v-model:y="y"
    :draggable="props.config.draggable || true" :resizable="props.config.resizable || true"
    :minW="props.config.minW || 300" :minH="props.config.minH || 200" :initW="props.config.initW || props.config.w || 300"
    :initH="props.config.initH || props.config.h || 200" :active="props.config.active || false"
    v-show="props.config.isShow" :class="props.config.customClass || ''" @drag-end="onResizing" @resize-end="onResizing">
    <slot></slot>
  </Vue3DraggableResizable>
</template>

<script setup lang="ts">
import { onUnmounted, watch, ref } from "vue";
const props = defineProps(["config"]);
const x = ref(props.config.x);
const y = ref(props.config.y);
const w = ref(props.config.w);
const h = ref(props.config.h);
let winWidth = window.innerWidth;
let winHeight = window.innerHeight;
// 拖动弹窗
const onResizing = (data: any) => {
  const { x, y, w, h } = data;
  let local: any = localStorage.getItem(props.config.nameSpace);
  if (local) {
    local = JSON.parse(local);
  } else {
    local = {
      x: 0,
      y: 0,
      w: 400,
      h: 300
    };
  }
  if (x) {
    local["x"] = x / window.innerWidth;
  }
  if (y) {
    local["y"] = y / window.innerHeight;
  }
  if (w) {
    local["w"] = w;
  }
  if (h) {
    local["h"] = h;
  }
  localStorage.setItem(props.config.nameSpace, JSON.stringify(local));
};

// 改变尺寸，重新设置位置、大小
const onResize = () => {
  winWidth = window.innerWidth;
  winHeight = window.innerHeight;
  let local: any = localStorage.getItem(props.config.nameSpace);

  if (local) {
    local = JSON.parse(local)
    if (local.x) {
      x.value = local.x > 1 ? local.x : winWidth * local.x;
    } else {
      x.value = props.config.x
    }
    if (local.y) {
      y.value = local.y > 1 ? local.y : winHeight * local.y;
    } else {
      y.value = props.config.y
    }
    if (local.w) {
      w.value = local.w;
    } else {
      w.value = props.config.w
    }
    if (local.h) {
      h.value = local.h;
    } else {
      h.value = props.config.h
    }
  } else {
    x.value = props.config.x || 0
    y.value = props.config.y || 0
    w.value = props.config.w || 500
    h.value = props.config.h || 400
    localStorage.setItem(props.config.nameSpace, JSON.stringify({
      x: x.value,
      y: y.value,
      w: w.value,
      h: h.value
    }));
  }
};

window.addEventListener("resize", onResize);
watch(
  () => props,
  (e) => {
    if (e.config.isShow) {
      onResize();
    }
  },
  { deep: true, immediate: true }
);

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});
</script>

<style lang="less">
.vdr-container {
  position: fixed !important;
  z-index: 5000;
}
</style>
